import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import {
  Menu,
  ShieldQuestion,
  Layout,
  AlertCircle,
  CreditCard,
  Coins,
  FolderSearch,
  LogOut,
  User,
  AlarmClockCheck,
  ArchiveIcon,
} from "lucide-react";
import { useUser } from "../contexts/UserContext"; // Add this import

const Navbar = ({ currentPage, onPageChange }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const { user } = useUser(); // Add user context
  const isAdmin = user?.role === "admin";
  const currentYear = new Date().getFullYear();

  const menuItems = [
    { id: "dashboard", icon: Layout, label: "Dashboard" },
    { id: "casino", icon: Coins, label: "Casinos" },
    { id: "transaction", icon: CreditCard, label: "Transactions" },
    { id: "session", icon: AlarmClockCheck, label: "Sessions" },
    { id: "alert", icon: AlertCircle, label: "Alerts" },
    { id: "archive", icon: ArchiveIcon, label: "Archive"},
  ];

  const bottomMenuItems = [
    { id: "profile", icon: User, label: "Profile" },
    { id: "contactUs", icon: ShieldQuestion, label: "Contact Us" },
    { id: "logout", icon: LogOut, label: "Logout" },
  ];

  const handleNavigation = (pageId) => {
    onPageChange(pageId);
    setIsCollapsed(true);
  };

  // const handleLogout = () => {
  //   logout({ returnTo: window.location.origin + '/login' });
  // };

  // const handleLogout = () => {
  //   logout({
  //     returnTo: window.location.origin + '/login',
  //     onRedirectCallback: () => {
  //       onPageChange('login'); // Update the current page to login
  //     }
  //   });
  // };

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
      onLogoutCallback: () => {
        onPageChange("login");
      },
    });
  };

  return (
    <>
      {/* Header with hamburger menu */}
      <div className="fixed top-0 left-0 right-0 h-16 bg-white shadow-sm z-20 lg:hidden">
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="p-4 hover:bg-gray-100"
          aria-label="Toggle menu"
        >
          <Menu size={24} className="text-gray-700" />
        </button>
      </div>

      {/* Overlay for mobile */}
      {!isCollapsed && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setIsCollapsed(true)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-full bg-blue-900 text-gray-300 
          transition-transform duration-300 ease-in-out z-40 w-64
          ${
            isCollapsed ? "-translate-x-full lg:translate-x-0" : "translate-x-0"
          }
          lg:sticky flex flex-col`}
      >
        {/* Logo Area */}
        <div className="h-16 flex items-center justify-between px-4 border-b border-blue-800">
          <span className="text-xl font-semibold">Daily Reward Tracker</span>
          {!isAuthenticated ? (
            <button
              onClick={() => loginWithRedirect()}
              className="px-4 py-2 text-sm bg-blue-700 text-white rounded-lg hover:bg-blue-600"
            >
              Login
            </button>
          ) : (
            <div className="flex items-center gap-2">
              <img
                src={user?.picture}
                alt={user?.name}
                className="w-8 h-8 rounded-full"
              />
            </div>
          )}
        </div>

        {/* Menu Items */}
        {isAuthenticated && (
          <nav className="p-4 space-y-2 flex-grow">
            {menuItems.map(({ id, icon: Icon, label }) => (
              <button
                key={id}
                onClick={() => handleNavigation(id)}
                className={`w-full flex items-center gap-4 px-4 py-3 rounded-lg transition-colors
                  ${
                    currentPage === id
                      ? "bg-blue-800 text-white"
                      : "hover:bg-blue-800 hover:text-white"
                  }`}
              >
                <Icon size={20} />
                <span className="font-medium">{label}</span>
              </button>
            ))}

            {/* User Profile and Logout */}
            <div className="pt-4 mt-4 border-t border-blue-800">
              <button
                onClick={() => handleNavigation("directory")}
                className="w-full flex items-center gap-4 px-4 py-3 rounded-lg hover:bg-blue-800 hover:text-white"
              >
                <FolderSearch size={20} />
                <span className="font-medium">Directory</span>
              </button>
              {/* {isAdmin ? (
                <button
                  onClick={() => handleNavigation("profile")}
                  className="w-full flex items-center gap-4 px-4 py-3 rounded-lg hover:bg-blue-800 hover:text-white"
                >
                  <User size={20} />
                  <span className="font-medium">Profile</span>
                </button>
              ) : null} */}
              <button
                onClick={() => handleNavigation("contactUs")}
                className="w-full flex items-center gap-4 px-4 py-3 rounded-lg hover:bg-blue-800 hover:text-white"
              >
                <ShieldQuestion size={20} />
                <span className="font-medium">Contact Us</span>
              </button>
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-4 px-4 py-3 rounded-lg hover:bg-blue-800 hover:text-white"
              >
                <LogOut size={20} />
                <span className="font-medium">Logout</span>
              </button>
            </div>
          </nav>
        )}

        <div className="p-4 text-center text-xs text-gray-400 border-t border-blue-800">
          <p>&copy; {currentYear} Daily Reward Tracker. All rights reserved.</p>
        </div>
      </aside>
    </>
  );
};

export default Navbar;
